import { PluggableStorage, PrefixKeyStrategy } from '@frontend/auth-helpers';
import { pseudonymize } from '../utils/obfuscation';

/**
 * storage where the keys are prefixed with the user's email for logged-out user-specific data
 */
export function getLoggedOutUserStore(username: string): PluggableStorage {
  const keyStrategy = new PrefixKeyStrategy(pseudonymize(username));
  return new PluggableStorage(keyStrategy, localStorage);
}
